/* eslint-disable import/no-default-export */
import {ThankYouPageController} from './ThankYouPageController';
import {IWidgetController} from '@wix/native-components-infra/dist/src/types/types';
import {ControllerParams} from '@wix/yoshi-flow-editor';
import {handleMultilingual} from '@wix/wixstores-client-storefront-sdk';

type AppDataWithReportError = {
  reportError?: (error: Error) => void;
};

export const controller = (controllerParams: ControllerParams): IWidgetController => {
  const siteStore = controllerParams?.appData?.context.siteStore;
  let controllerClass: ThankYouPageController | undefined;

  const getController = async () => {
    if (controllerClass) {
      return controllerClass;
    }
    await siteStore.loadClientConfig();
    controllerClass = new ThankYouPageController(controllerParams);
    return controllerClass;
  };

  return {
    async pageReady() {
      try {
        const controllerInstance = await getController();

        const isMultilingualNeeded = () => {
          const multilingualFields = siteStore.getMultiLangFields();
          return (
            controllerParams.controllerConfig.config.externalId &&
            multilingualFields &&
            !multilingualFields?.isPrimaryLanguage
          );
        };

        const shouldCallAppSettings = isMultilingualNeeded();

        await Promise.all([
          ...(shouldCallAppSettings ? [handleMultilingual(controllerParams, controllerInstance.getFreeTexts())] : []),
          controllerInstance.init(),
        ]);
        controllerParams.controllerConfig.wixCodeApi.location.onChange(() => void controllerInstance?.load());
      } catch (error) {
        /* istanbul ignore next */
        console.error(error);
        /* istanbul ignore next */
        (controllerParams.appData as AppDataWithReportError)?.reportError?.(error as Error);
      }
    },
    exports() {
      return getExportsAfterControllerLoaded(getController, ['getOrder']);
    },
    updateConfig: (_$w, updatedConfig: {[key: string]: any}): void => {
      return void controllerClass?.onStyleUpdate?.(updatedConfig.style.styleParams);
    },
  };
};

function getExportsAfterControllerLoaded(getController: () => Promise<ThankYouPageController>, keys: string[]) {
  return keys.reduce<Record<string, (...args: any[]) => any>>((acc, key) => {
    acc[key] = async (...args: any[]) => {
      const resolvedController = await getController();
      return resolvedController.exports()[key](...args);
    };
    return acc;
  }, {});
}

export default controller;
